// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Bgu8","list":"styles_list__3KHsf"};